export default __webpack_public_path__ + "static/media/benefit1.a585a016.png";